'use client'

import * as React from 'react'
import type { FormFieldContextValue } from '../types/FormFieldContextValue'

/**
 * React context to provide the form field name to nested components.
 * @internal
 */
export const FormFieldContext = React.createContext<FormFieldContextValue>(
  {} as FormFieldContextValue
)
